import { colors } from '@fs/zion-ui'
import React, { Children, type ReactNode } from 'react'
import { css } from '@emotion/core'
import { ResponsiveProvider } from '@fs/zion-ui/quarks-authorized-use-only'
import { minWidthCss } from './common'
import { hasValidChildren } from '../hasValidChildren'

const flexCss = css`
  display: flex;
  flex-direction: column;
`

const backgroundColorCss = css`
  background-color: ${colors.gray00};
`

const borderCss = css`
  background-color: ${colors.transparent.gray10};
  display: grid;
  gap: 1px;
`

const responsiveProviderCss = css`
  display: flex;
  flex-direction: column;
  flex: 1;
`

type Props = {
  children: ReactNode
  columnCount?: number
}

/** A 2 column grid with exact 1px border in between */
export default function InBetweenBorderGrid({ children, columnCount = 1 }: Props): JSX.Element {
  return (
    <div css={borderCss} style={{ gridTemplateColumns: `repeat(${columnCount}, 1fr)` }}>
      {Children.map(children, (child) => {
        if (hasValidChildren(child)) {
          return (
            <div css={[flexCss, backgroundColorCss, minWidthCss]}>
              <ResponsiveProvider css={responsiveProviderCss}>{child}</ResponsiveProvider>
            </div>
          )
        }
        return null
      })}
    </div>
  )
}
